export type NavigationCategory = {
	id: string
	name: string
	slug: string
	description?: string | null
	parentId?: string | null
	position?: number | null
}

export type NavigationCategoryTree = {
	rootCategories: NavigationCategory[]
	childCategoriesByParentId: Map<string, NavigationCategory[]>
}

export function buildCategoryTree(
	categories?: NavigationCategory[],
): NavigationCategoryTree {
	const all = Array.isArray(categories) ? categories : []
	const sorted = [...all].sort((a, b) => {
		const posA = typeof a.position === 'number' ? a.position : 0
		const posB = typeof b.position === 'number' ? b.position : 0
		if (posA !== posB) return posA - posB
		return a.name.localeCompare(b.name)
	})

	const rootCategories = sorted.filter((category) => !category.parentId)
	const childCategoriesByParentId = new Map<string, NavigationCategory[]>()

	for (const category of sorted) {
		if (!category.parentId) continue
		const siblings = childCategoriesByParentId.get(category.parentId) ?? []
		siblings.push(category)
		childCategoriesByParentId.set(category.parentId, siblings)
	}

	return { rootCategories, childCategoriesByParentId }
}
